<template>
    <section class="offline-stores-sec" v-if="$store.state.settings.site_id === 1">
        <div class="container">
            <div class="offline-stores-sec__banner">
                <picture>
                    <source media="(max-width: 599px)" :srcset="'/img/offline-shops-mob.webp'" type="image/webp">
                    <img :src="'/img/offline-shops.webp'" alt="" class="offline-stores-sec__img">
                </picture>
                <div class="offline-stores-sec__content">
                    <h2 class="offline-stores-sec__title">{{ trans('OFFLINE STORES') }}</h2>
                    <a href="/stores?utm_russia=1" class="btnV1 offline-stores-sec__btn">
                        {{ trans('STORE ADDRESSES') }}
                    </a>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    name: "offline-stores-sec",
}
</script>
